import { BASE_PATH } from "./constants";
const CONFIG_ENDPOINT = `${BASE_PATH}config`;
const getConfigRequestUrl = ({ baseUrl, xSiteOrigin, language, country, keyStoreDataversion, }) => {
    const url = new URL(CONFIG_ENDPOINT, baseUrl);
    url.search = new URLSearchParams({
        country,
        lang: language,
        keystoredataversion: keyStoreDataversion,
        ...(xSiteOrigin ? { "x-site-origin": xSiteOrigin } : {}),
    }).toString();
    return url.toString();
};
export default getConfigRequestUrl;
